import { render, staticRenderFns } from "./TrainingStatsView.vue?vue&type=template&id=b654d218&scoped=true&"
import script from "./TrainingStatsView.vue?vue&type=script&lang=js&"
export * from "./TrainingStatsView.vue?vue&type=script&lang=js&"
import style0 from "./TrainingStatsView.vue?vue&type=style&index=0&id=b654d218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b654d218",
  null
  
)

export default component.exports